import React from 'react';
import './index.css';
import axios from 'axios';
import ProjectDetail from './ProjectDetail';
import { Container, Row, Col, Spinner, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

class ProjectContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: [],
      isLoading: true,
      category: '',
      page: 1,
      countPage: '',
    };
  }

  handleGetAPI = () => {
    axios({
      method: 'get',
      url: `https://eclipsesp-app.herokuapp.com/projek?page=${this.state.page}`,
      // responseType: 'stream'
    })
      .then((res) => {
        this.setState({
          project: [...this.state.project, res.data.data.rows],
          isLoading: false,
          countPage: res.data.totalPages,
        });
      })
      .catch((err) => console.log(err));
  };

  handleGetProjectByCategory = () => {
    let category = this.props.match.params.category;
    axios({
      method: 'get',
      url: `https://eclipsesp-app.herokuapp.com/projek/category/${category}`,
      // responseType: 'stream'
    })
      .then((res) => {
        this.setState({
          project: [res.data.data],
          isLoading: false,
        });
      })
      .catch((err) => console.log(err));
  };

  handleDetail = (id) => {
    // this.history.entries = [];
    // this.history.index = -1;
    const { history } = this.props;
    history.push(`/project-desc/${id}`);
  };

  handlePage = () => {
    if (this.state.page < this.state.countPage) {
      this.setState({
        page: this.state.page + 1,
      });
    }
  };

  componentDidMount() {
    let category = this.props.match.params.category;
    // console.log('awal', category);
    if (!category) {
      this.handleGetAPI();
    } else {
      this.handleGetProjectByCategory();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.props.location.pathname);
    let category = this.props.match.params.category;
    let page = this.state.page;
    if (category !== prevProps.match.params.category) {
      this.handleGetProjectByCategory();
    } else if (page !== prevState.page) {
      this.handleGetAPI();
    }
  }

  componentWillUnmount() {}

  render() {
    // console.log(this.props.detailProject);
    // console.log(this.state.project);
    // let arrangeData = [],
    //   columns = [];
    // this.state.project.forEach((proj, idx) => {
    //   //prepare array
    //   columns.push(
    //     <Col
    //       className="my-4"
    //       xs={{ span: 12 }}
    //       md={{ span: 6 }}
    //       lg={{ span: 4 }}
    //     >
    //       <ProjectDetail
    //         key={proj.id}
    //         projek={proj}
    //         detailProject={this.handleDetail}
    //       />
    //     </Col>
    //   );

    //   // add row in after three items
    //   if ((idx + 1) % 3 === 0) {
    //     console.log(columns);
    //     arrangeData.push(<Row>{columns}</Row>);
    //     columns = [];
    //   }
    //   return arrangeData;
    //   idx % 3 === 0
    //     ? arrangeData.push(
    //         <Row>
    //           <Col md={{ span: 4 }}>
    //             <ProjectDetail key={proj.id} projek={proj} />
    //           </Col>
    //         </Row>
    //       )
    //     : arrangeData.push(
    //         <Col md={{ span: 4 }}>
    //           <ProjectDetail key={proj.id} projek={proj} />
    //         </Col>
    //       );
    // });

    return (
      <div>
        <div className="catalog-bg">
          {this.state.isLoading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <Container fluid="lg">
              <Row>
                {this.state.project.map((val, idx) => {
                  return val.map((proj, id) => {
                    return (
                      <Col
                        key={id}
                        className="my-4"
                        xs={{ span: 12 }}
                        md={{ span: 4 }}
                        lg={{ span: 4 }}
                      >
                        <ProjectDetail
                          key={idx}
                          projek={proj}
                          detailProject={this.handleDetail}
                        />
                      </Col>
                    );
                  });
                })}
              </Row>
              <div className="d-flex justify-content-center py-5">
                {this.state.countPage ? (
                  <Button variant="outline-dark" onClick={this.handlePage}>
                    load more
                  </Button>
                ) : (
                  <div></div>
                )}
              </div>
            </Container>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(ProjectContainer);
